<template>
  <div class="app" style="background-color:#fff">
     <ks-header title="支付订单"></ks-header>
    <div class="money">
      <div class="money-amount"><a class="money-amount__y">¥</a>{{discount.price}}</div>
      <div class="monery-discount">铂金优惠 购买折扣{{discount.discount}}折</div>
    </div>
    <div class="payment">
      <div class="payment-mode">请选择支付方式</div>
      <div class="payment-balance">余额支付</div>
       <div class="payment-ble">您的可用余额：¥{{$store.state.userData.Money}}元
         <van-radio checked-color="#FF795C" class="ks-fr" v-model="payid" name="0"></van-radio>
       </div>
       <!-- 输入金额 -->
       <van-cell-group  v-if="payid == 0">
          <van-field
            v-model="payMoney"
            label="输入金额"
            type="number"
            placeholder="输入可用金额"
            rows="1"
            @blur="setPrice"
            autosize
          />
        </van-cell-group>
    <div class="modelist">
      <div v-for="item in payList" :key="item.payId">
        <div class="ks-line"></div>
        <div class="modelist-ble">
          <img class="modelist-ble__img" :src="item.logo">
          <van-radio checked-color="#FF795C" class="ks-fr"  v-model="payid" :name="item.payId"></van-radio>
        </div>
      </div>
    </div>
    </div>
      <van-button round size="large" @click="goPay">确认支付</van-button>
  </div>
</template>

<script>
import {GetPaymentList,GetDiscountCardDetial,DoPayDiscountCard}  from '@/apis/user'
export default{
  name:'DiscountPayment',
  data(){
     return {
      payid: '0',
      payMoney:0,
      payList:[],
      discount:{}
    }
  },
  created(){
    let _cardid = this.$route.params.id
    GetDiscountCardDetial({
      cardid:_cardid,
      schoolid:SCHOOL_ID
    }).then(res=>{
     this.discount = res.data[0];
    })
    /**
     * 获取支付方式
     */
    GetPaymentList().then(res=>{
      this.payList = res.data;

    });
  },
  methods:{
    setPrice(){//判断输入金额
        this.$store.ready(state=>{
          if(this.payMoney > state.userData.Money){
            this.payMoney = state.userData.Money
          }
        })
    },
    goPay(){
      let _cardid = this.$route.params.id
      DoPayDiscountCard({
          payid:this.payid,
          cardid:_cardid,
          schoolid:SCHOOL_ID
      }).then(res=>{
        if(res.result){
          this.$toast.success('支付成功');
          this.$router.back(-1)
        }else{
          if(res.payurl){
            location.href = res.payurl
          }else{
            this.$toast.fail('支付失败');
          }
        }
      })

    }
  }
}
</script>

<style scoped>
.money{
  padding-top: 40px;
  text-align: center;
}
.money-amount{
  font-size:33px;
  font-weight:bold;
}
.money-amount__y{
  font-size:22px;
}
.monery-discount{
  font-size:13px;
  color: #999999;
}
.payment{
  padding: 44px 15px 0 15px;
}
.payment-mode{
  font-size: 14px;
  font-weight: bold;
}
.payment-balance{
  font-size: 13px;
  font-weight: bold;
  margin-top: 18px;
  margin-bottom: 15px;
}
.payment-ble{
  font-size: 13px;
  color: #999999;
  margin-bottom: 15px;
}
 .van-button{
    position: relative;
    top:90%;
    width: 85%;
    height: 44px;
    line-height: 44px;
    background-color: #FF795C;
    font-size: 15px;
    font-weight:600;
    color: #FFF;
    margin:30px 8% 20px 8%;
}
.modelist-ble__img{
    position: absolute;
    height: 25px;
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: 70px;
  }
  .modelist-ble{
    padding:17px 0;
    margin-bottom: 24px;
  }
  .van-cell{
    padding: 10px 0px;
  }
</style>





// WEBPACK FOOTER //
// src/pages/user/DiscountPayment.vue